import React, { useContext, useEffect } from "react";
import LeftSideBar from "../../components/LeftSideBar";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  Text,
  VStack,
  useDisclosure,
  useMediaQuery,
  Box,
  Link as ChakraLink,
  useToast,
  useColorModeValue
} from "@chakra-ui/react";
import { AppContext } from "../../context/AppContext";
import Navbar from "../../components/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { FaInstagram, FaTelegram } from 'react-icons/fa';
import SelectService from "../../components/SelectService";
import { GetBalanceAPI, LogoutApi } from "../../utils/api";
const Home = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isDark, Token, setBalance, balance, handleLogout, setDefaultServer, defaultServer, setUserEmail } = useContext(AppContext);
  const location = useLocation();
  const toast = useToast();
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  useEffect(() => {
    GetBalanceAPI(Token).then((res) => {
      setBalance(res.data.balance);
      setDefaultServer(res.data.defaultServer)
      setUserEmail(res.data.email);
    }).catch((err) => {
      handleLogout(err);
    })
  }, []);
  return (
    <VStack w={"100%"}>
      <Navbar onOpen={onOpen} />
      <HStack
        align={"start"}
        mt={"0 !important"}
        minH={"100%"}
        justify={"start"}
        w={"100%"}
      >
        {isLargerThan992 ? <LeftSideBar /> : <></>}
        {location.pathname == "/" && <SelectService server={defaultServer} />}
        <Drawer
          placement={"left"}
          onClose={onClose}
          isOpen={isOpen}
          size={["xs", "sm", "md", "md"]}
        >
          <DrawerOverlay backdropFilter="blur(4px)" />
          <DrawerContent
            bg={useColorModeValue("rgba(255, 255, 255, 0.95)", "rgba(26, 32, 44, 0.95)")}
            backdropFilter="blur(16px)"
            boxShadow="xl"
            borderRight="1px solid"
            borderColor={useColorModeValue("gray.200", "gray.700")}
          >
            <DrawerCloseButton
              size="lg"
              top={4}
              right={4}
              color={useColorModeValue("gray.600", "gray.400")}
              _hover={{ bg: useColorModeValue("gray.100", "whiteAlpha.200") }}
            />
            <DrawerHeader
              borderBottomWidth="1px"
              borderColor={useColorModeValue("gray.100", "gray.700")}
              py={6}
            >
              <VStack align="start" spacing={1}>
                <HStack
                  bg={useColorModeValue("brand.50", "whiteAlpha.100")}
                  px={3}
                  py={1}
                  rounded="full"
                  spacing={2}
                >
                  <Text fontSize="sm" color={useColorModeValue("gray.600", "gray.400")}>
                    Balance:
                  </Text>
                  <Text fontSize="md" fontWeight="bold" color="brand.500">
                    ₹{Number(balance).toFixed(2)}
                  </Text>
                </HStack>
              </VStack>
            </DrawerHeader>
            <DrawerBody p={0}>
              <LeftSideBar closeDrawer={onClose} status={true} />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        <Box zIndex={10} position={'fixed'} bottom={['0.5rem', '0.9rem', '1rem', '1rem']} right={['0.5rem', '0.9rem', '1rem', '1rem']} fontSize={'3rem'} >
          <ChakraLink href="https://telegram.me/TechyindiaorgOfficialnews" target={"_blank"}>
            <FaTelegram style={{
              color: '#3390EC',
              cursor: 'pointer'
            }} />
          </ChakraLink>
        </Box>
        <Outlet />
      </HStack>
    </VStack>
  );
};

export default Home;
